module.exports = __webpack_public_path__ + "static/media/podcast.56791c16.svg";